module.exports = __webpack_public_path__ + "static/media/right_answer.7240df92.mp3";